import {useState, useEffect} from 'react';
import { TextInput, Button } from '@mantine/core';
import { Search, X, ArrowBigRight, ArrowBackUp } from 'tabler-icons-react';
import { Flights } from './Flights';
import { prepareForLogout } from './Helpers';

interface SearchProps {
    isDarkTheme: boolean,
    updateShowSessionError: (arg: boolean) => void
}

export const Searchbar = (props: SearchProps) => {
    const [value, setValue] = useState('');
    const [noSearchResults, setNoSearchResults] = useState(false);

    function clearSearch() {
        setValue('');
        setFlightSearchResults('');
    }

    // Handle enter/return key
    useEffect(() => {
        function handleKeyDown(e: any) {
            if (e && e.keyCode && e.keyCode == 13) {
                performSearch();
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    function createParamString() {
        var paramString = '';
        //TODO: will any of these change?
        paramString += '?onlyProprietary=true&searchFieldGroup=tobt_mobile_search&fieldGroup=tobt_mobile&stateGroup=tobt_mobile&direction=outbound&sort[0][field]=flight_id_field_name&sort[0][dir]=asc';
        if (value) {
            paramString += '&query=' + value;
        } else if (value === '' && document && document.getElementById('search') != null) {     //TODO investigate this bug, sometimes value is empty when enter key is used
            let searchVal : string = (document.getElementById('search') as HTMLInputElement).value;;
            paramString += '&query=' + searchVal;
        }

        return paramString;
    }

    function performSearch() {
        var sessionVal = '';
        if (sessionStorage.getItem('sessionId')) {
            if (sessionStorage && sessionStorage.getItem('sessionId')) {
                const session = sessionStorage.getItem('sessionId');
                if (session != null) {
                    sessionVal = session;
                }
            }
        }
        const request = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET',
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Authorization',
                'X-Requested-With': 'XMLHttpRequest',
                'X-Saab-SessionID': sessionVal,
                'Www-Authenticate': 'BASIC realm="aerobahn"'
            }
        };
        fetch('/externalApi/search/v2/flight' + createParamString(), request ).then(function (response) {
            if (response && response.status && response.status === 401) {
                props.updateShowSessionError(true);
                prepareForLogout();
            } else if (!response.ok) {
                const error: any = new Error('HTTP error! status: ${response.status}');
                error.status = response.status;
                throw error;
            }
            return response.json();
        }).then(function (result) {
            if (result.length > 0) {
                setNoSearchResults(false);
            } else {
                setNoSearchResults(true);
            }
            setFlightSearchResults(result);
        }).catch((err : any) => {
            console.warn('Error with status code: ' + err);
            if (err === 401) {
                prepareForLogout();
                props.updateShowSessionError(true);
            } else {
                setNoSearchResults(true);
            }
        });
    }

    function toggleFlightList() {
        performSearch();
        setShowFlightList(true);
    }

    const updateShowFlightList = (showFlightList: boolean):void => {
        setShowFlightList(showFlightList);
    }

    const [flightSearchResults, setFlightSearchResults] = useState('');
    const [showFlightList, setShowFlightList] = useState(true);

    function onChange(val : string) {
        if (val === '') {
            setFlightSearchResults('');
        }
        setValue(val);
        setNoSearchResults(false);
    }

    return (
        <div>
            { showFlightList ? 
            <TextInput 
                value={value}
                id="search"
                onChange={(event) => onChange(event.currentTarget.value)}
                icon={<Search
                        size={20}
                        strokeWidth={2}
                        color={'white'}
                    />}
                color="white"
                placeholder="Search by Flight"
                rightSection={
                    <Button.Group>
                        {value !== '' && 
                            <div style={{display:'contents'}}>
                            <Button 
                                rightIcon={<X size={20} color={props.isDarkTheme ? 'white' : 'grey'}/>}
                                variant="subtle"
                                compact
                                onClick={clearSearch}
                                >
                            </Button>       
                            <Button 
                                leftIcon={<ArrowBigRight size={20} color={props.isDarkTheme ? 'white' : 'grey'}/>}
                                variant="subtle"
                                compact
                                onClick={performSearch}
                                >
                            </Button>
                            </div>
                        }
                    </Button.Group>
                }
            /> : null }
            { !showFlightList ? 
                <Button 
                    leftIcon={<ArrowBackUp size={20} color={props.isDarkTheme ? 'white' : 'grey'}/>}
                    variant="subtle"
                    color="white"
                    style={{color: props.isDarkTheme ? 'white' : 'grey', fontWeight:500}}
                    onClick={toggleFlightList}
                    >
                    Flight List
                </Button>
            : null }
            <div>
                <Flights updateShowFlightList={updateShowFlightList} 
                        value={value} 
                        flights={flightSearchResults} 
                        showFlightList={showFlightList} 
                        performSearch={performSearch} 
                        isDarkTheme={props.isDarkTheme} 
                        updateShowSessionError={props.updateShowSessionError}
                        noSearchResults={noSearchResults}></Flights>
            </div>
        </div>
      );
}